module.exports = __webpack_public_path__ + "static/img/doge.ae64499c.png";